const TEXT = {
    SHOP_CONTENT_TEXT_0:"云仓补货",
    SHOP_CONTENT_TEXT_1:"我要进货",
    SHOP_CONTENT_TEXT_2:"实体库存",
    SHOP_CONTENT_TEXT_3:"没有更多了",
    SHOP_CONTENT_TEXT_4:"结算",
    SHOP_CONTENT_TEXT_5:"共计",
    SHOP_CONTENT_TEXT_6:"不含运费",
    SHOP_CONTENT_TEXT_7:"确认订单",
    SHOP_CONTENT_TEXT_8:"收货人",
    SHOP_CONTENT_TEXT_9:"运费",
    SHOP_CONTENT_TEXT_10:"配送方式",
    SHOP_CONTENT_TEXT_11:"快递",
    SHOP_CONTENT_TEXT_12:"买家留言",
    SHOP_CONTENT_TEXT_13:"件商品",
    SHOP_CONTENT_TEXT_14:"小计",
    SHOP_CONTENT_TEXT_15:"提交订单",
    SHOP_CONTENT_TEXT_16:"确认付款",
    SHOP_CONTENT_TEXT_17:"线上支付",
    SHOP_CONTENT_TEXT_18:"微信支付",
    SHOP_CONTENT_TEXT_19:"线下支付",
    SHOP_CONTENT_TEXT_20:"支付宝支付",
    SHOP_CONTENT_TEXT_21:"银行卡支付",
    SHOP_CONTENT_TEXT_22:"立即支付",
    SHOP_CONTENT_TEXT_23:"支付成功",
    SHOP_CONTENT_TEXT_24:"订单支付成功",
    SHOP_CONTENT_TEXT_25:"去看看",
    SHOP_CONTENT_TEXT_26:"添加收货地址",
    SHOP_CONTENT_TEXT_27:"选填：请填写您的要求",
    SHOP_CONTENT_TEXT_28:"余额",
    SHOP_CONTENT_TEXT_29:"现金",
    SHOP_CONTENT_TEXT_30:"云库存",
    SHOP_CONTENT_TEXT_31:"上传付款凭证",
    SHOP_CONTENT_TEXT_32:"提交",
    SHOP_CONTENT_TEXT_33:"库存",

};
export {
	TEXT
}


// WEBPACK FOOTER //
// ./src/config/page/cn/shop/index.js